(function () {
  'use strict';

  var AUTOPLAY_INTERVAL = 3000;
  var MAX_RETRIES = 10;
  var RETRY_DELAY = 300;
  var LOG_PREFIX = '[Anber autoplay]';
  var SECTION_KEYS = [
    'best-sellers',
    'new-arrivals',
    'for-her',
    'for-him',
    'unisex-carousel',
    'gift-carousel',
    'top-sellers'
  ];

  function log(sectionKey, message) {
    if (window.console && window.console.debug) {
      window.console.debug(LOG_PREFIX, '[' + sectionKey + ']', message);
    }
  }

  function initAutoplay(sectionEl, sectionKey) {
    var slider = sectionEl.querySelector('slider-component');
    if (!slider) {
      log(sectionKey, 'no se encontro <slider-component> dentro de la seccion.');
      return;
    }

    var track = slider.querySelector('[id^="Slider-"]');
    var nextButton = slider.querySelector('button[name="next"]');

    if (!track || !nextButton) {
      log(sectionKey, 'no se encontro el track o el boton "next" dentro del slider.');
      return;
    }

    log(sectionKey, 'slider y boton next encontrados. Autoplay listo cada ' + AUTOPLAY_INTERVAL + 'ms (arranca al entrar en pantalla).');

    var intervalId = null;
    var paused = false;
    var visible = false;

    function advance() {
      if (nextButton.hasAttribute('disabled')) {
        log(sectionKey, 'boton next deshabilitado (fin del carrusel): volviendo al inicio.');
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        log(sectionKey, 'avanzando al siguiente producto.');
        nextButton.click();
      }
    }

    function start() {
      if (intervalId !== null) {
        return;
      }
      intervalId = window.setInterval(advance, AUTOPLAY_INTERVAL);
      log(sectionKey, 'autoplay activo.');
    }

    function stop() {
      if (intervalId !== null) {
        window.clearInterval(intervalId);
        intervalId = null;
        log(sectionKey, 'autoplay pausado.');
      }
    }

    function sync() {
      if (visible && !paused) {
        start();
      } else {
        stop();
      }
    }

    function pause() {
      paused = true;
      sync();
    }

    function resume() {
      paused = false;
      sync();
    }

    // A proposito no hay pausa al arrastrar/tocar el carrusel: el pedido
    // explicito fue que el autoplay "no se pare" cuando el cliente lo
    // mueve a mano. Solo se pausa con el mouse encima (para poder leer
    // /hacer click con calma) o cuando sale de pantalla.
    slider.addEventListener('mouseenter', pause);
    slider.addEventListener('mouseleave', resume);
    slider.addEventListener('focusin', pause);
    slider.addEventListener('focusout', resume);

    // El "advance()" de arriba ya hace que el autoplay vuelva al inicio
    // al llegar al final, pero eso no cubre que el cliente arrastre el
    // carrusel a mano hasta el ultimo producto: ahi se quedaba topado,
    // sin poder seguir. Este listener detecta cuando el scroll (venga
    // de donde venga: autoplay, arrastre con mouse o swipe tactil) se
    // asento en el limite derecho real y lo manda de vuelta al inicio,
    // para que el carrusel se sienta infinito se mueva como se mueva.
    var wrapTimeoutId = null;
    track.addEventListener(
      'scroll',
      function () {
        if (wrapTimeoutId !== null) {
          window.clearTimeout(wrapTimeoutId);
        }
        wrapTimeoutId = window.setTimeout(function () {
          var maxScrollLeft = track.scrollWidth - track.clientWidth;
          if (maxScrollLeft > 0 && track.scrollLeft >= maxScrollLeft - 2) {
            log(sectionKey, 'fin del carrusel alcanzado a mano: volviendo al inicio.');
            track.scrollTo({ left: 0, behavior: 'smooth' });
          }
        }, 500);
      },
      { passive: true }
    );

    if (window.IntersectionObserver) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            visible = entry.isIntersecting;
            sync();
          });
        },
        { threshold: 0.25 }
      );
      observer.observe(sectionEl);
    } else {
      visible = true;
      sync();
    }
  }

  function tryInit(sectionKey, attempt) {
    var section = document.querySelector('[id$="__' + sectionKey + '"]');

    if (!section) {
      if (attempt < MAX_RETRIES) {
        window.setTimeout(function () {
          tryInit(sectionKey, attempt + 1);
        }, RETRY_DELAY);
      } else {
        log(sectionKey, 'no se encontro la seccion tras varios intentos. Autoplay no arranca.');
      }
      return;
    }

    log(sectionKey, 'seccion encontrada.');
    initAutoplay(section, sectionKey);
  }

  // A proposito el autoplay ya NO respeta prefers-reduced-motion: es un
  // carrusel de contenido (productos), no una animacion decorativa, y
  // el propio dueno de la tienda tiene esa preferencia activada en su
  // sistema -- respetarla dejaba el autoplay permanentemente invisible
  // para el. Decision explicita del usuario, confirmada 2026-07-08.
  function init() {
    SECTION_KEYS.forEach(function (sectionKey) {
      tryInit(sectionKey, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
